//polyfills for compiling
import "core-js/stable";
import "regenerator-runtime/runtime";
//polyfill libraries
import 'promise-polyfill/src/polyfill';
import 'whatwg-fetch';

//css
import './styles/main.scss';
import './styles/editor.scss';

//scripts
import User from './scripts/users/user.js';
import ManageCompanyUsersForm from './scripts/users/manageCompanyUsers.js';
import MembersJoinForm from './scripts/forms/MembersJoinForm.js';
import NewsletterForm from './scripts/forms/newsletterForm.js';
import ContactForm from './scripts/forms/contactUsForm.js';
import SubmitQuestionForm from './scripts/forms/submitQuestion.js';
import ImageSlider from './scripts/ui/imageSlider.js';
import PostListBlock from './scripts/ui/postListBlock.js';
import './scripts/ui/cardCarousel.js';
import './scripts/ui/scrollTo.js';
import './scripts/ui/passwords.js';
import './scripts/ui/clearForm.js';
import './scripts/forms/jobApplication.js';
import './scripts/ui/bioLaunch.js';
import './scripts/ui/tabs.js';
import './scripts/utilities/objectFitIEFix.js';

//manage company users form
if( document.getElementsByClassName('manage-company-users-cont').length > 0 ){
  [...document.getElementsByClassName('manage-company-users-cont')].forEach( function( formEl ){
    if( typeof manageCompanyFormUsers !== undefined && typeof orgId !== undefined ){
      let formUsers = [];
      manageCompanyFormUsers.forEach( formUser => {
        let user = new User( formUser.email, formUser.name );
        formUsers.push( user );
      })
      let manageCompanyUsersForm = new ManageCompanyUsersForm( formEl, formUsers, orgId );
    }
  })
}

//image slider
if( document.getElementsByClassName('image-slider').length > 0 ){
  [...document.getElementsByClassName('image-slider')].forEach( function( sliderEl ){
    let slider = new ImageSlider( sliderEl );
    slider.start();
  })
}

//forms
//become a member
if( document.getElementsByClassName('member-join-form').length ){
  [...document.getElementsByClassName('member-join-form')].forEach( formEl => {
    let formId = parseInt(formEl.getAttribute('data-form-id'), 10);
    if( formId > 0 ){
      let membersJoinForm = new MembersJoinForm( formEl, formId );
    }
  })
}
//newsletter form
if( document.getElementsByClassName('newsletter-form').length ){
  [...document.getElementsByClassName('newsletter-form')].forEach( formEl => {
    let formId = parseInt(formEl.getAttribute('data-form-id'), 10);
    if( formId > 0 ){
      let newsletterForm = new NewsletterForm( formEl, formId );
    }
  })
}
//contact form
if( document.getElementsByClassName('contact-us-form').length ){
  [...document.getElementsByClassName('contact-us-form')].forEach( formEl => {
    let formId = parseInt(formEl.getAttribute('data-form-id'), 10);
    if( formId > 0 ){
      let newsletterForm = new ContactForm( formEl, formId );
    }
  })
}

//Submit q and a question
if( document.getElementsByName('submit-q-and-a-question').length > 0 ){
  let formEl = document.getElementsByName('submit-q-and-a-question')[0];
  let submitQuestionForm = new SubmitQuestionForm( formEl, 'submit-q-and-a-question' );
  console.log(submitQuestionForm);
}

//post list block
if( document.getElementsByClassName('post-list-container').length > 0 ){
  [...document.getElementsByClassName('post-list-container')].forEach( element => {
    let postListBlock = new PostListBlock( element );
    console.log(postListBlock);
  })
}
